<template lang="pug">
.listing-assign-item
  v-divider.my-3
  .pl-16.pr-6
    .d-flex.align-start
      .text-sm.font-semibold.flex-grow-1 {{ $t('assign_team') }}
      v-btn.button-xs.underline.px-0.mt-n1(text :loading="leftBtnLoading" @click="$emit('leftBtnClicked')") {{ leftBtnText }}
      v-btn.button-xs.underline.px-0.mt-n1.mr-n4(text :loading="rightBtnLoading" @click="$emit('rightBtnClicked')") {{ rightBtnText }}
    div
      .user-badge.mr-2(v-for="label in labels")
        v-icon.mr-1(size=11 color="primary") $yzi-user-01
        span.text-xs {{ label }}
</template>

<script>
export default {
  name: 'ListingAssignItem',
  props: {
    labels: {
      type: Array,
      default: null
    },
    rightBtnText: {
      type: String,
      required: true 
    },
    leftBtnText: {
      type: String,
      required: true 
    },
    rightBtnLoading: {
      type: Boolean,
    },
    leftBtnLoading: {
      type: Boolean,
    },
  }
}
</script>

<style lang="scss" scoped>
.user-badge {
  background: #F9FAFB !important;
  color: #333333 !important;
  border-radius: 6px;
  display: inline-flex;
  position: relative;
  align-items: center;
  vertical-align: middle;
  padding: 0 6px;
  height: 24px;
  border: 1px solid #EEEEEE;
}
</style>